// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"710":"9a5a1c86","6965":"dee90363","7639":"631744e0"}[chunkId] + ".chunk.css";
};